import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-EULA',
    templateUrl: './EULA.component.html',
    imports: [CommonModule, RouterModule]
})
export class EULAComponent {
}
